import { customAlphabet } from 'nanoid'

// Make sure to only use 10 alphanumeric characters for our user handles
// According to https://zelark.github.io/nano-id-cc/ we would have a 1% probability of collision after 15 years if we create 1k handles per hour
// That is only the case for the short id itself, since we are also adding the firstname infront of it, the probability of collision is even lower
const idGenerator = customAlphabet('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ', 10)

export function getShortIdGenerator(): () => string {
  return idGenerator
}

/**
 * Creates a new user handle for the given firstname
 * If present the passed in id generator will be used
 */
export function createUserHandle(firstname?: string | null, idGenerator?: () => string) {
  const parts = [
    firstname?.replace(/[^a-zA-Z0-9]/g, '').toLowerCase(),
    idGenerator ? idGenerator() : getShortIdGenerator()(),
  ]

  return parts.filter(Boolean).join('-')
}
